import { Controller } from '@hotwired/stimulus'

export default class OptimisticLikeController extends Controller {
  static targets = ['count', 'icon', 'link']

  static values = {
    liked: Boolean,
    count: Number,
    likedIcon: String,
    unlikedIcon: String
  }

  connect() {
    this.pending = false
  }

  async toggle(event) {
    event.preventDefault()

    if (this.pending) return

    this.pending = true
    const previous = {
      liked: this.likedValue,
      count: this.countValue
    }

    this.renderState(!previous.liked)

    try {
      const response = await fetch(this.linkTarget.href, {
        method: previous.liked ? 'DELETE' : 'POST',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector(
            'meta[name="csrf-token"]'
          )?.content || '',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`Like request failed with status ${response.status}`)
      }

      if (response.redirected) {
        throw new Error('Like request was redirected')
      }

      const stream = await response.text()
      if (!stream.trim()) throw new Error('Like request returned no update')

      Turbo.renderStreamMessage(stream)
    } catch (error) {
      this.likedValue = previous.liked
      this.countValue = previous.count
      this.updateElements()
      console.error('Unable to update like:', error)
    } finally {
      this.pending = false
    }
  }

  renderState(liked) {
    this.countValue = Math.max(
      0,
      this.countValue + (liked ? 1 : -1)
    )
    this.likedValue = liked
    this.updateElements()
  }

  updateElements() {
    this.countTargets.forEach(element => {
      element.textContent = this.countValue
    })

    if (this.hasIconTarget) {
      this.iconTarget.src = this.likedValue
        ? this.likedIconValue
        : this.unlikedIconValue
    }

    this.linkTarget.setAttribute('aria-pressed', String(this.likedValue))
  }
}
